import { useDispatch, useSelector } from 'react-redux';
import type { TypedUseSelectorHook } from 'react-redux'
import storage from "redux-persist/lib/storage";
// import { createRootStore } from "@parent-app/redux-state";
import { createRootStore } from '../../shared/redux-state/src/index';

const persistConfig = {
    key: 'root',
    storage,
    blacklist: ['timeline'],
    whitelist: ['persistLogin', 'login', 'timeline.filters', 'nurserySetting', 'eymemoryPersistLogin', 'eymemoryLogin', 'appInfo'],
};


const middlewares: any[] = [];

export const { store, persistor } = createRootStore(persistConfig, middlewares);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector